import { adminApi } from './ApiService';

// ── Activities (Calendar/Diary) ──────────────────────────
export const activityService = {
  list: (params = {}) => adminApi.get('/admin/activities', params),
  create: (data) => adminApi.post('/admin/activities', data),
  update: (id, data) => adminApi.patch(`/admin/activities/${id}`, data),
  delete: (id) => adminApi.delete(`/admin/activities/${id}`),
};

// ── Sales Pipeline ───────────────────────────────────────
export const pipelineService = {
  list: (params = {}) => adminApi.get('/admin/pipeline', params),
  create: (data) => adminApi.post('/admin/pipeline', data),
  update: (id, data) => adminApi.patch(`/admin/pipeline/${id}`, data),
  delete: (id) => adminApi.delete(`/admin/pipeline/${id}`),
};

// ── Business Goals ───────────────────────────────────────
export const goalsService = {
  list: (params = {}) => adminApi.get('/admin/goals', params),
  create: (data) => adminApi.post('/admin/goals', data),
  update: (id, data) => adminApi.patch(`/admin/goals/${id}`, data),
  delete: (id) => adminApi.delete(`/admin/goals/${id}`),
};

// ── Referrals ────────────────────────────────────────────
export const referralService = {
  list: (params = {}) => adminApi.get('/admin/referrals', params),
  create: (data) => adminApi.post('/admin/referrals', data),
  update: (id, data) => adminApi.patch(`/admin/referrals/${id}`, data),
  delete: (id) => adminApi.delete(`/admin/referrals/${id}`),
};

// ── Resellers ────────────────────────────────────────────
export const resellerService = {
  list: (params = {}) => adminApi.get('/admin/resellers', params),
  get: (id) => adminApi.get(`/admin/resellers/${id}`),
  create: (data) => adminApi.post('/admin/resellers', data),
  update: (id, data) => adminApi.patch(`/admin/resellers/${id}`, data),
  delete: (id) => adminApi.delete(`/admin/resellers/${id}`),
};

export const resellerSaleService = {
  list: (params = {}) => adminApi.get('/admin/reseller-sales', params),
  create: (data) => adminApi.post('/admin/reseller-sales', data),
  update: (id, data) => adminApi.patch(`/admin/reseller-sales/${id}`, data),
  delete: (id) => adminApi.delete(`/admin/reseller-sales/${id}`),
};

export const resellerPayoutService = {
  list: (params = {}) => adminApi.get('/admin/reseller-payouts', params),
  create: (data) => adminApi.post('/admin/reseller-payouts', data),
  update: (id, data) => adminApi.patch(`/admin/reseller-payouts/${id}`, data),
};

// ── Reseller Portal (for reseller users) ────────────────
export const resellerPortalService = {
  getMe: () => adminApi.get('/admin/reseller-portal/me'),
  updateMe: (data) => adminApi.patch('/admin/reseller-portal/me', data),
  mySales: (params = {}) => adminApi.get('/admin/reseller-portal/my-sales', params),
  myPayouts: (params = {}) => adminApi.get('/admin/reseller-portal/my-payouts', params),
  getProducts: () => adminApi.get('/admin/reseller-portal/products'),
  registerSale: (data) => adminApi.post('/admin/reseller-portal/register-sale', data),
};

// ── Communication Templates ─────────────────────────────
export const templateService = {
  list: (params = {}) => adminApi.get('/admin/templates', params),
  create: (data) => adminApi.post('/admin/templates', data),
  update: (id, data) => adminApi.patch(`/admin/templates/${id}`, data),
  delete: (id) => adminApi.delete(`/admin/templates/${id}`),
};

// ── Suggestions (user feedback) ─────────────────────────
export const suggestionService = {
  list: (params = {}) => adminApi.get('/admin/suggestions', params),
  update: (id, data) => adminApi.patch(`/admin/suggestions/${id}`, data),
  delete: (id) => adminApi.delete(`/admin/suggestions/${id}`),
};

// ── Social Media ─────────────────────────────────────────
export const socialAccountService = {
  list: (params = {}) => adminApi.get('/admin/social-accounts', params),
  create: (data) => adminApi.post('/admin/social-accounts', data),
  update: (id, data) => adminApi.patch(`/admin/social-accounts/${id}`, data),
  delete: (id) => adminApi.delete(`/admin/social-accounts/${id}`),
};

export const socialPostService = {
  list: (params = {}) => adminApi.get('/admin/social-posts', params),
  create: (data) => adminApi.post('/admin/social-posts', data),
  update: (id, data) => adminApi.patch(`/admin/social-posts/${id}`, data),
  delete: (id) => adminApi.delete(`/admin/social-posts/${id}`),
  publish: (id) => adminApi.post(`/admin/social-posts/${id}/publish`),
};
